import('core-js/stable');
// import('reactstrap');
